import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IS_API_GATEWAY,IS_PRIVATE_API } from '@personal-area/common';

import { AccountAnalytics } from '../models/account-analytics';

const endpoints = {
  fetch: (accountID: number): string =>
    `/v1/account-analytics/${accountID}`,
};

@Injectable({
  providedIn: 'root',
})
export class AccountAnalyticsApiService {
  constructor(private _http: HttpClient) {}

  public fetchAnalytics(
    accountID: number,
    dateFrom: string,
    dateTo: string
  ): Observable<AccountAnalytics> {
    return this._http.get<AccountAnalytics>(endpoints.fetch(accountID), {
      params: { dateFrom, dateTo },
      context: new HttpContext().set(IS_PRIVATE_API, true).set(IS_API_GATEWAY, true),
    });
  }
}
